import Immutable from 'immutable';
import React from 'react';
import ArtboardLayoutContainerList from 'components/ArtboardLayoutContainerList';
import { CAROUSEL_ITEM_TYPE_HINT_TEXT } from 'components/Carousel/Carousel';
import { CarouselItemDragHotSpot } from 'components/Carousel/CarouselItemDragHotSpot';
import styles from 'components/Carousel/styles.module.scss';
import { useCarouselItemDropTarget } from 'components/Carousel/useCarouselItemDropTarget';
import { CarouselItemType } from 'containers/Layouts/sagas/addCarousel';
import * as Models from 'models';

type Props = {
  carouselId: string;
  documents?: Models.CombinedDocumentsMap;
  getLayoutsRefs?: () => Immutable.Map<string, HTMLDivElement>;
  isSectionActive: boolean;
  isReadOnly: boolean;
  layoutIds: Immutable.List<string>;
  moveableLayoutId?: string;
  relationsByRegularLayoutId?: Immutable.Map<string, Models.LayeredRelationsMap>;
  saveLayoutRef?: (layoutId: string, element: HTMLDivElement) => void;
  section: Models.ExtendedSectionMap;
  type: CarouselItemType;
  carouselItemLayouts: Models.CombinedLayoutsList;
  sectionDisplayName: string;
};

const CarouselItem: React.FC<Props> = (props) => {
  const {
    carouselId,
    documents,
    getLayoutsRefs,
    isSectionActive,
    isReadOnly,
    layoutIds,
    moveableLayoutId,
    relationsByRegularLayoutId,
    saveLayoutRef,
    section,
    type,
    carouselItemLayouts,
    sectionDisplayName,
  } = props;
  const sectionId = section.get('id');
  const { canDrop, drop } = useCarouselItemDropTarget({ sectionId, carouselId, type, sectionDisplayName });

  return (
    <div ref={drop} className={styles.carouselItem}>
      <div className={styles.carouselItemType}>{CAROUSEL_ITEM_TYPE_HINT_TEXT[type]}</div>
      <CarouselItemDragHotSpot canDrop={canDrop} />
      <ArtboardLayoutContainerList
        documents={documents}
        getLayoutsRefs={getLayoutsRefs}
        isSectionActive={isSectionActive}
        layoutIds={layoutIds}
        isReadOnly={isReadOnly}
        layouts={carouselItemLayouts}
        moveableLayoutId={moveableLayoutId}
        relationsByRegularLayoutId={relationsByRegularLayoutId}
        saveLayoutRef={saveLayoutRef}
        section={section}
        ssi={null}
        dataTestId={`Carousel-${carouselId}-${type}-ArtboardLayoutContainerList`}
      />
    </div>
  );
};

export default CarouselItem;
